module.exports = __webpack_public_path__ + "img/user-05.1c0efd4b.jpg";